import { useEffect, useState } from "react";
import { getStateList, StateOption } from "utils/api/lookupApi";

export function useStateList(): { stateList: StateOption[]; isLoading: boolean } {
  const [stateList, setStateList] = useState<StateOption[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    getStateList().then((list) => {
      if (cancelled) return;
      setStateList(list);
      setIsLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { stateList, isLoading };
}

export default useStateList;
